import React, { useState } from 'react';

import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Measure from 'react-measure';
import { isMobile } from 'react-device-detect';

const stepsBreakpoint = 1179;
export interface IStep {
  disabled?: boolean;
  name: string;
  status: 'active' | 'disabled' | 'done' | '';
}

interface IProps {
  active: number;
  steps: IStep[];
  onChange: (event: any, active: number) => void;
}

export const Stepper = (props: IProps) => {
  const [appBarWidth, setAppBarWidth] = useState(stepsBreakpoint);

  const { active, steps, onChange } = props;

  return isMobile ? (
    <></>
  ) : (
    <>
      <Measure
        bounds={true}
        onResize={contentRect => {
          if (contentRect.bounds) {
            setAppBarWidth(contentRect.bounds.width);
          }
        }}
      >
        {({ measureRef }) => (
          <div ref={measureRef} className="event-wizard-tab-submenu-container">
            <AppBar className="event-wizard-tab-submenu">
              <Tabs
                value={active}
                onChange={onChange}
                classes={{
                  flexContainer: 'tabs-container override',
                  indicator: 'tab-indicator',
                  scrollButtons: 'scroll-button'
                }}
                centered={appBarWidth > stepsBreakpoint}
                variant={appBarWidth < stepsBreakpoint ? 'scrollable' : undefined}
                scrollButtons="auto"
              >
                {steps.map((step, index) => (
                  <Tab
                    classes={{ wrapper: 'tab-label', selected: 'selected-tab' }}
                    className="event-wizard-tab override"
                    key={`tab-round-${step.name}-${index}`}
                    label={`${index + 1}. ${step.name}`}
                    disabled={step.disabled}
                    id={`scrollable-auto-tab-${index}`}
                    aria-controls={`scrollable-auto-tabpanel-${index}`}
                  />
                ))}
              </Tabs>
            </AppBar>
          </div>
        )}
      </Measure>
    </>
  );
};
